import { Component, inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { Router, RouterModule } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import {
  ReactiveFormsModule,
  FormBuilder,
  Validators,
  FormGroup,
} from '@angular/forms';
import { LoginUser } from '../../../core/models/login-user.model';
import { AuthService } from '../../../core/services/auth/auth.service';
import { ErrorResponse } from '../../../core/models/error-response.model';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ErrorSnackBarComponent } from '../../../shared/snack-bars/error-snack-bar/error-snack-bar.component';
import { finalize } from 'rxjs';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RecaptchaEnterpriseService } from '@core/services/recaptcha/recaptcha-enterprise.service';
import { FcmService } from '@core/services/fcm-message/fcm.service';

@Component({
  selector: 'app-login',
  imports: [
    RouterModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css',
})
export class LoginComponent implements OnInit {
  private _snackBarError = inject(MatSnackBar);
  private recaptchaService = inject(RecaptchaEnterpriseService);
  private fcmService = inject(FcmService);

  credentials: LoginUser = {
    usuario: '',
    password: '',
    fcm_token:''
  };
  loginForm!: FormGroup;
  /***
   * Variable para ocultar la contraseña
   */
  hide = true;

  cargando: boolean = false;
  constructor(
    private formBuilder: FormBuilder,
    private auth: AuthService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    /***
     * Campos del formulario
     */
    this.loginForm = this.formBuilder.group({
      username: [
        '',
        [
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(30),
        ],
      ],
      password: [
        '',
        [
          Validators.required,
          Validators.minLength(6),
          Validators.maxLength(100),
        ],
      ],
    });
  }

  /**
   * Envía los datos del Usuario para acceder al dashboard
   */
  public async login() {
    if (this.loginForm.valid) {
      try {
        const token = await this.recaptchaService.executeAction('LOGIN');
        const fcmToken = await this.fcmService.getDeviceToken();
       console.log('TOKEN PARA PRUEBAS:', fcmToken);
        // if (fcmToken == null) return;
        this.credentials = {
          usuario: this.username?.value,
          password: this.password?.value,
          recaptcha_token: token,
          fcm_token:fcmToken ?? '',
        };

        console.log(this.credentials);
        

        this.cargando = true;
        this.auth
          .login(this.credentials)
          .pipe(finalize(() => (this.cargando = false)))
          .subscribe({
            next: (perfil) => {
              console.log(
                'Login y carga de perfil exitosos para:',
                perfil?.nombre,
              );
              if (perfil?.rol?.nivel === 5) {
                // this.router.navigate(['/dashboard']);
                this.router.navigate(['/dashboard/company/list']);
              } else {
                this.router.navigate(['/dashboard/company/list']);
              }
            },
            error: (error: ErrorResponse) => {
              this.username?.setErrors({
                notMatch: true,
              });
              this.openSnackBarError(error);
            },
          });
      } catch (error) {
        console.error('Error generando el token:', error);
      }
    }
  }

  public openSnackBarError(error: ErrorResponse) {
    let snackBarrError = this._snackBarError.openFromComponent(
      ErrorSnackBarComponent,
      {
        data: error,
        horizontalPosition: 'start',
        verticalPosition: 'top',
      },
    );
    snackBarrError.onAction().subscribe(() => {
      this.username?.enable();
    });

    snackBarrError.afterDismissed().subscribe(() => {
      this.username?.enable();
    });
  }

  /**
   * Getters para obtener datos de cada formControl
   */
  get username() {
    return this.loginForm.get('username');
  }
  /**
   * Getters para obtener datos de cada formControl
   */
  get password() {
    return this.loginForm.get('password');
  }
}
